(() => {
  'use strict';

  const cfg = window.Ar3xanReleasitLegacyConfig || {};
  const PRODUCT_ID = '10424578179368';
  const EXPECTED = [1, 2, 3];
  const BASE_PRICE = Number(cfg.basePrice);
  if (!Number.isFinite(BASE_PRICE) || BASE_PRICE <= 0) return;
  const formatCop = value => `$${Math.round(value).toLocaleString('es-CO')} COP`;
  const formatMoney = value => `$${Math.round(value).toLocaleString('es-CO')}`;
  const TOTALS = {
    1: BASE_PRICE,
    2: BASE_PRICE * 1.8,
    3: BASE_PRICE * 2.55,
  };
  const SAVINGS = {
    2: BASE_PRICE * 0.2,
    3: BASE_PRICE * 0.45,
  };
  const COPY = {
    1: { title: 'RECIBE 1 KIT AR3XAN', plaque: '35% DE DESCUENTO', detail: '1 AR3XAN + 1 BIOA-HRTRI' },
    2: { title: 'RECIBE 2 KITS AR3XAN', plaque: '20% DE DESCUENTO ADICIONAL', detail: `AHORRAS ${formatMoney(SAVINGS[2])}` },
    3: { title: 'RECIBE 3 KITS AR3XAN', plaque: '45% DE DESCUENTO ADICIONAL', detail: `AHORRAS ${formatMoney(SAVINGS[3])}` },
  };

  const PROMO = {
    1: {
      headline: 'OFERTA DEL KIT: 35% DE DESCUENTO',
      lead: `Recibes 1 frasco de AR3XAN de 60 tabletas + 1 gel BIOA-HRTRI de 90 g por ${formatCop(TOTALS[1])} en total.`,
      ribbon: 'Oferta activa — pide tu Kit AR3XAN y paga cuando recibas.',
    },
    2: {
      headline: 'OFERTA 2 KITS: SEGUNDO KIT CON 20% DE DESCUENTO',
      lead: `Recibes 2 frascos de AR3XAN de 60 tabletas + 2 geles BIOA-HRTRI de 90 g por ${formatCop(TOTALS[2])} en total.`,
      ribbon: `Ahorras ${formatMoney(SAVINGS[2])} — pide hoy y paga cuando recibas.`,
    },
    3: {
      headline: 'OFERTA 3 KITS: TERCER KIT CON 45% DE DESCUENTO',
      lead: `Recibes 3 frascos de AR3XAN de 60 tabletas + 3 geles BIOA-HRTRI de 90 g por ${formatCop(TOTALS[3])} en total.`,
      ribbon: `Ahorras ${formatMoney(SAVINGS[3])} — pide hoy y paga cuando recibas.`,
    },
  };
  const IMAGES = { 1: cfg.images?.one, 2: cfg.images?.two, 3: cfg.images?.three };

  const visible = el => !!el && el.getClientRects().length > 0;
  const text = el => (el?.textContent || '').replace(/\s+/g, ' ').trim();

  function isAr3xanPage() {
    if (String(cfg.productId || '') !== PRODUCT_ID) return false;
    return location.pathname.includes('/products/kit-ar3xan') || location.pathname.includes('/products_preview');
  }

  function modal() {
    return [...document.querySelectorAll('#_rsi-cod-form-modal')].find(visible) || null;
  }

  function offers(root) {
    return [...root.querySelectorAll('._rsi-quantity-offers-offer-container')].filter(visible).slice(0, 3);
  }

  function offerQuantity(offer, index) {
    const candidates = [
      offer.dataset.quantity,
      offer.querySelector('[data-quantity]')?.dataset.quantity,
      offer.querySelector('input[type="radio"]')?.value,
      offer.querySelector('input[type="hidden"]')?.value,
    ];
    for (const value of candidates) {
      const n = Number(String(value || '').match(/\d+/)?.[0]);
      if (EXPECTED.includes(n)) return n;
    }
    return EXPECTED[index] || null;
  }

  function firstByClasses(root, classes) {
    for (const cls of classes) {
      const el = root.querySelector(cls);
      if (el) return el;
    }
    return null;
  }

  function setText(el, value) {
    if (el && text(el) !== value) el.textContent = value;
  }

  function setOfferCopy(offer, qty) {
    const c = COPY[qty];
    if (!c) return;
    const title = firstByClasses(offer, ['._rsi-quantity-offers-title', '._rsi-quantity-offer-title', '._rsi-quantity-offer-name', '._rsi-quantity-offer-label']);
    const plaque = firstByClasses(offer, ['._rsi-quantity-offers-plaque', '._rsi-quantity-offer-discount', '._rsi-quantity-offer-badge', '._rsi-quantity-offer-plaque']);
    let detail = firstByClasses(offer, ['.ar3xan-releasit-offer-detail', '._rsi-quantity-offer-subtitle', '._rsi-quantity-offer-description', '._rsi-quantity-offer-detail']);
    if (!detail) {
      const host = firstByClasses(offer, ['._rsi-quantity-offers-info', '._rsi-quantity-offer-info']);
      if (host) {
        detail = document.createElement('div');
        detail.className = 'ar3xan-releasit-offer-detail';
        host.appendChild(detail);
      }
    }
    setText(title, c.title);
    setText(plaque, c.plaque);
    setText(detail, c.detail);
    const img = offer.querySelector('img');
    if (img && IMAGES[qty]) {
      if (img.src !== IMAGES[qty]) img.src = IMAGES[qty];
      img.alt = `${qty} ${qty === 1 ? 'kit' : 'kits'} AR3XAN: ${qty * 2} productos`;
      img.loading = 'eager';
    }
    offer.dataset.ar3xanOffer = String(qty);
  }

  function ensureHeading(root) {
    const native = [...root.querySelectorAll('._rsi-custom-text-field')].find(el => /elige tu oferta/i.test(text(el)));
    setText(native, '1 - ELIGE TU OFERTA DEL KIT AR3XAN 👇');
  }

  function selectedQuantity(root, list) {
    const checked = root.querySelector('._rsi-quantity-offers-offer-container input:checked')?.closest('._rsi-quantity-offers-offer-container');
    if (checked) return offerQuantity(checked, list.indexOf(checked));
    const selected = list.find(o => o.classList.contains('_rsi-quantity-offers-selected') || o.classList.contains('_rsi-selected') || o.getAttribute('aria-checked') === 'true');
    if (selected) return offerQuantity(selected, list.indexOf(selected));
    return 1;
  }


  function ensurePromo(root, qty) {
    const promo = PROMO[qty];
    if (!promo) return;
    let box = root.querySelector('[data-ar3xan-promo]');
    if (!box) {
      box = document.createElement('section');
      box.dataset.ar3xanPromo = 'true';
      box.className = 'ar3xan-releasit-promo';
      const marker = [...root.querySelectorAll('._rsi-custom-text-field')].find(el => /elige tu oferta/i.test(text(el))) || root.querySelector('._rsi-quantity-offers-container');
      if (!marker) return;
      marker.parentNode.insertBefore(box, marker);
    }
    const html = `<h3>${promo.headline}</h3><div class="ar3xan-releasit-promo__card"><p><strong>${promo.lead}</strong></p><p>Envío incluido y pago contraentrega. Pagas cuando recibes tu pedido.</p><p>Selecciona tu oferta y completa los datos de entrega.</p></div><p class="ar3xan-releasit-promo__ribbon">${promo.ribbon}</p>`;
    if (box.innerHTML !== html) box.innerHTML = html;
  }

  function enhance() {
    if (!isAr3xanPage()) return;
    const root = modal();
    if (!root) return;
    const list = offers(root);
    if (list.length !== 3) return; // Never simulate app-owned offers.
    ensureHeading(root);
    list.forEach((offer, index) => setOfferCopy(offer, offerQuantity(offer, index)));
    const qty = selectedQuantity(root, list);
    ensurePromo(root, qty);
    root.querySelector('[data-ar3xan-offer-summary]')?.remove();
    root.dataset.ar3xanReleasitEnhanced = 'true';
  }

  let queued = false;
  let scopedRoot = null;
  let scopedObserver = null;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  }

  function attachModal(root) {
    if (!root || root === scopedRoot) return;
    scopedObserver?.disconnect();
    scopedRoot = root;
    scopedObserver = new MutationObserver(schedule);
    scopedObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked'],
    });
    schedule();
  }

  function discoverModal(node) {
    const root = node?.matches?.('#_rsi-cod-form-modal')
      ? node
      : node?.querySelector?.('#_rsi-cod-form-modal') || document.querySelector('#_rsi-cod-form-modal');
    if (root) attachModal(root);
  }

  document.addEventListener('click', event => {
    const card = event.target.closest('._rsi-quantity-offers-offer-container');
    if (card) {
      const root = modal();
      const list = root ? offers(root) : [];
      const index = list.indexOf(card);
      if (root && index >= 0) ensurePromo(root, offerQuantity(card, index));
      setTimeout(schedule, 80);
      setTimeout(schedule, 250);
      setTimeout(schedule, 500);
    }
    if (event.target.closest('#_rsi-buy-now-button,[data-arx-purchase-link]')) {
      [0, 50, 150, 300, 600, 1200].forEach(delay => setTimeout(() => discoverModal(), delay));
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.closest('#_rsi-cod-form-modal')) schedule();
  }, true);

  const pageObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('#_rsi-cod-form-modal') || node.querySelector?.('#_rsi-cod-form-modal')) {
          discoverModal(node);
          return;
        }
      }
    }
  });
  discoverModal();
  pageObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
